import cn from 'classnames';
import { ExpertStatus } from '@packages/shared/core/experts/entities';
import styles from './ExpertStatusIndicator.module.scss';

type ExpertStatusIndicatorProps = {
  status?: ExpertStatus;
  className?: string;
};

const ExpertStatusIndicator = ({ status = ExpertStatus.OFFLINE, className = '' }: ExpertStatusIndicatorProps) => {
  const pointClasses = cn({
    [styles.root]: true,
    [styles.online]: status === ExpertStatus.ONLINE,
    [styles.busy]: status === ExpertStatus.BUSY,
    [className]: !!className,
  });

  return <div className={pointClasses} />;
};

export default ExpertStatusIndicator;
